<template>
  <div class="wishlist">
    <div class="container">
      <div class="wishlist__wrapper">
        <div class="wishlist__top">
          <h1 class="wishlist__title">{{ t('wishlist.title1') }} <span>{{ t('wishlist.title2') }}</span></h1>
        </div>
        <i18n-t class="wishlist__subtext" tag="p" scope="global" keypath="wishlist.text">
          <template #quantity>
            <span>{{ productsInWishlist.length }}</span>
          </template>
        </i18n-t>
        <div class="wishlist__grid">
          <product-card
              v-for="product in productsInWishlist"
              :key="product.uuid"
              :product="product.node"
          />
        </div>
      </div>
    </div>
    <transition name="opacity" mode="out-in">
      <product-view
          v-if="activeViewProduct"
          :product="activeViewProduct"
      />
    </transition>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed} from "vue";
import {useWishlistStore} from "@/stores/wishlist.js";
import ProductCard from "@/components/cards/product-card.vue";
import ProductView from "@/components/cards/product-view.vue";
import {useAppStore} from "@/stores/app.js";

const {t} = useI18n()
const wishlistStore = useWishlistStore()
const appStore = useAppStore()

const productsInWishlist = computed(() => {
  return wishlistStore.wishlist.products ? wishlistStore.wishlist.products.edges : []
})

const activeViewProduct = computed(() => {
  return appStore.activeViewProduct
})
</script>

<style lang="scss" scoped>
.wishlist {
  padding-top: 150px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 35px;
  }

  &__top {
    border-bottom: 1px solid #EDEDED;
  }

  &__title {
    width: fit-content;
    padding-right: 50px;
    padding-bottom: 10px;
    border-bottom: 3px solid #008ECC;
    color: #666;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;

    & span {
      color: #008ECC;
    }
  }

  &__subtext {
    color: #222;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  &__grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(225px, 225px));
    column-gap: 20px;
    row-gap: 30px;
    justify-content: space-between;
  }
}

@media (max-width: 600px) {
  .wishlist {
    &__grid {
      justify-content: center;
    }
  }
}
</style>